import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { LoggerService } from './services/logger.service';
import { getColor } from './shared';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styles: [` `]
})
export class AppComponent {
  public appPages = [
    {
      title: 'Home',
      url: '/home',
      icon: 'home'
    },
    {
      title: 'Nuovo incarico test',
      url: '/test',
      icon: 'logo-android'
    },
    {
      title: 'Solera',
      url: '/solera',
      icon: 'home'
    }, {
      title: 'Storage',
      url: '/storage',
      icon: 'home'
    }, {
      title: 'Uploader',
      url: '/uploader',
      icon: 'home'
    },
    {
      title: 'Logout',
      url: '/login/out',
      icon: 'exit'
    }
  ];

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private logger: LoggerService,
  ) {
    this.initializeApp();

    console.log('prova')



  }
  color;
  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();



      this.color = getColor();


    });
  }
}


